import React from 'react'
import {
  Bullet,
  Bullets,
  Info,
  Page,
  Screenshot,
  Section,
} from '../../components/DocsComponents'
import DocLink from '../../components/DocLink'

const MeetingsAndAnnouncements = () => (
  <Page
    title="Meetings and Announcements"
    intro="Governance meetings give structured agendas and meeting notes for recurring governance activity, while announcements handle wider organisation communication."
  >
    <Section title="Governance meetings">
      <Bullets>
        <Bullet>
          Open <DocLink url="/meetings" text="Meetings" /> to see past and
          upcoming governance meetings, and schedule one from{' '}
          <DocLink url="/meetings/new" text="New Meeting" />.
        </Bullet>
        <Bullet>
          Give each meeting a type - Governance, Operational, Event Planning,
          or Other - alongside its date, location, and invitees.
        </Bullet>
        <Bullet>
          Build the agenda as ordered items, each with a title, description,
          lead, an estimated time, and optional CQC key question tags (Safe,
          Effective, Caring, Responsive, Well-Led).
        </Bullet>
        <Bullet>
          During or after the meeting, use each agenda item's{' '}
          <strong>Mark Complete</strong> switch to show it has been covered,
          and record the discussion in the meeting's overall{' '}
          <strong>Meeting Notes</strong> editor.
        </Bullet>
      </Bullets>
      <Screenshot url="governance/meetings.png">
        The Meetings page listing past and upcoming governance meetings with
        their types and dates.
      </Screenshot>
      <Info title="Who can do this?">
        All meeting pages require the Governance team (site administrators
        always have access). Governance meetings are a tier 2 feature.
      </Info>
    </Section>

    <Section title="Announcements">
      <p>
        Announcements are available from{' '}
        <DocLink url="/announcements" text="Announcements" /> at the top of
        the sidebar. They're used for organisation-wide communication, can
        carry attachments, and can require staff to acknowledge them - each
        announcement tracks who has acknowledged it.
      </p>
      <Bullets>
        <Bullet>
          Accepted MHRA safety alerts can be published as announcements
          automatically, with acknowledgement required and a link to the MHRA
          notice.
        </Bullet>
      </Bullets>
      <Info title="Who can do this?">
        Every signed-in user can read and acknowledge announcements. Creating
        one requires the Manager, Supervisor, or Governance team; editing or
        deleting an
        existing announcement requires the Governance team (site
        administrators always have access). Announcements are not
        subscription-gated.
      </Info>
    </Section>
  </Page>
)

export default MeetingsAndAnnouncements
